import React, { useMemo, memo } from "react";
import PT from "prop-types";
import * as S from "./styled";
import moment from "moment";
import MetaCounter from "_c/MetaCounter";
import ShareIcon from "_c/icon/Share";
import CommentIcon from "_c/icon/Comment";
import StarIcon from "_c/icon/Star";
import { LinkGenerator } from "@/utils/LinkGenerator";
import { SITE_URL } from "@/misc/constants";

import Review from "_c/review";
import Portfolio from "./Portfolio";

const getComponent = (type) => {
  if (type === "Review") {
    return Review;
  }
  if (type === "Portfolio") {
    return Portfolio;
  }
  return null;
};
const extractComponentProps = ({ type, ...props }) => {
  const sharedProps = {
    addComment: (entityId, payload) =>
      props.addComment(entityId, type, payload),
    toggleLike: () => props.toggleLike(props.data._id, type),
    openShareModal: props.openShareModal,
    removeComment: (entityId, commentId) =>
      props.removeComment(entityId, commentId, type),
  };
  if (type === "Review") {
    return {
      ...sharedProps,
      review: props.data,
      loadComments: () => props.loadComments(props.data._id, type),
      isAuth: props.isAuth,
      isAuthor: props.authUserId === props.data.client._id,
      hidePhotoButton: true,
      authUserId: props.authUserId,
    };
  }
  if (type === "Portfolio") {
    return {
      ...sharedProps,
      portfolio: props.data,
      openGallery: props.openPortfolioGallery,
    };
  }
  return {};
};
const FeedItem = ({ t, ...props }) => {
  const Component = getComponent(props.type);
  const componentProps = extractComponentProps(props);
  const isFav = useMemo(() => {
    return props.favorites.includes(props.data._id);
  }, [props.favorites, props.data._id]);
  const onShare = () => {
    if (props.type === "Review") {
      props.openShareModal(SITE_URL + LinkGenerator.review(props.data._id));
    } else if (props.type === "Portfolio") {
      props.openShareModal(SITE_URL + LinkGenerator.portfolio(props.data._id));
    }
  };
  return (
    <S.Wrap>
      <S.ActivityType>
        {t(
          `client_profile:feed.activity_desc.${props.type}_${
            props.isOwner ? "owner" : "guest"
          }`
        )}
      </S.ActivityType>
      <S.Head>
        <time dateTime={props.date}>{moment(props.date).calendar()}</time>
        <S.AsideAvatar
          avatar={props.clientAvatar}
          sex={props.clientSex}
        ></S.AsideAvatar>
        <S.HeadMetaGroup>
          <MetaCounter
            onClick={() => props.toggleLike(props.data._id, props.type)}
            count={props.data.likes_count}
          >
            <StarIcon filled={isFav} color="var(--color-primary)" />
          </MetaCounter>
          <MetaCounter count={props.data.comments_count}>
            <CommentIcon color="var(--color-primary)" />
          </MetaCounter>
          <MetaCounter onClick={onShare}>
            <ShareIcon color="var(--color-primary)" />
          </MetaCounter>
        </S.HeadMetaGroup>
      </S.Head>
      <S.ComponentWrap>
        {Component && (
          <Component isFavorite={isFav} t={t} {...componentProps} />
        )}
      </S.ComponentWrap>
    </S.Wrap>
  );
};
FeedItem.displayName = "FeedItem";
FeedItem.propTypes = {
  type: PT.string,
  data: PT.object,
  date: PT.string,
  isOwner: PT.bool,
  clientAvatar: PT.string,
  clientSex: PT.bool,
  isAuth: PT.bool,
  authUserId: PT.string,

  addComment: PT.func.isRequired,
  removeComment: PT.func.isRequired,
  openShareModal: PT.func.isRequired,
  loadComments: PT.func.isRequired,
  t: PT.func.isRequired,
  toggleLike: PT.func.isRequired,
  openPortfolioGallery: PT.func.isRequired,
};
export default memo(FeedItem);
